import AdaVideoInTxt from '@/components/Advertising/Ada/AdaVideoInTxt'

const AdslotVideoIntxt = () => <AdaVideoInTxt />

export default AdslotVideoIntxt
